import { Component, OnInit } from '@angular/core';
import { selectCurrentHeadlessStepperStep } from '../../../../../ngrx/misc/misc.selectors';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { toggleHeadlessStepperStep } from '../../../../../ngrx/misc/misc.actions';
import { resetUserPinStart } from '../../../../../ngrx/auth/auth.actions';
import { Router } from '@angular/router';
import { initRecaptcha } from '../../../../../../assets/utility';
import { AsyncPipe } from '@angular/common';
import { NewPinComponent, ResetFormBody } from '../new-pin/new-pin.component';
import { ConfirmNinComponent } from '../confirm-nin/confirm-nin.component';
import { BeyHeadlessStepperComponent } from '../../../../shared/components/bey-headless-stepper/bey-headless-stepper.component';

@Component({
  selector: 'app-reset-process',
  templateUrl: './reset-process.component.html',
  styleUrls: ['./reset-process.component.scss'],
  standalone: true,
  imports: [BeyHeadlessStepperComponent, ConfirmNinComponent, NewPinComponent, AsyncPipe],
})
export class ResetProcessComponent implements OnInit {
  currentStep$: Observable<number>;
  forms: { step1: UntypedFormGroup; step2: FormGroup<ResetFormBody> } = { step1: null, step2: null };
  routerData: { otp_token: string; phone: string; otp: string };

  constructor(private router: Router, private store: Store) {
    this.currentStep$ = store.select(selectCurrentHeadlessStepperStep);

    const currentNavigation = this.router.getCurrentNavigation();
    const data = currentNavigation?.extras?.state;

    if (data) {
      this.routerData = {
        otp: data['otp'],
        otp_token: data['otp_token'],
        phone: data['phone'],
      };
    } else {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit(): void {}

  handleStepData({ formGroup, step }: { formGroup: UntypedFormGroup; step: number }) {
    this.forms[`step${step}`] = formGroup;

    switch (step) {
      case 1:
        this.store.dispatch(toggleHeadlessStepperStep({ currentStep: step }));
        break;

      case 2:
        const { id_number }: { id_number: string } = this.forms.step1.value;
        const { pin } = this.forms.step2.value;

        initRecaptcha('reset_pin_with_id')
          .then((recaptcha) => {
            this.store.dispatch(
              resetUserPinStart({
                payload: {
                  phone: this.routerData.phone,
                  requestBody: { new_pin: Number(pin), recaptcha, otp_token: this.routerData.otp_token, id_number },
                },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          });

        break;
    }
  }
}
